import { config, hammerIt, responsive, debounce } from '../../../utilities';
import { initMarkers, initFilters } from '../../common/interactive-map';

function scaleFilters($filters) {
    const $filtersItems = $filters.find('.imap__filters-inner .imap__filters__item');

    function resize() {
        $filtersItems.each((_, filtersItem) => {
            $(filtersItem).removeAttr('style');

            responsive.breakAt({
                callback: () => {
                    responsive.overflownTextScale($(filtersItem).get(0));
                },
                to: 'md',
            });
        });
    }

    resize();
    window.addEventListener('resize', debounce(resize, 300));
}

export default function initMobileInteractiveMapPopup() {
    const $popupImgOuter = $('.popup .imap__map-outer');
    const $mapFilters = $('.popup .imap__filters');
    if (!$popupImgOuter.length) {
        return;
    }
    const windowH = window.innerHeight;
    const h = $mapFilters.outerHeight() || 0;
    const imgW = (windowH - h) / config.aerialMap.aspectRatio;
    const defaultScrollLeft = (imgW - $popupImgOuter.outerWidth()) / 2;
    const defaultScrollTop = (h - $popupImgOuter.outerHeight()) / 2;
    $popupImgOuter.find('.imap__map-container').css('width', imgW);
    $popupImgOuter.scrollLeft(defaultScrollLeft);
    $popupImgOuter.scrollTop(defaultScrollTop);

    initMarkers($popupImgOuter.find('.imap__marker'), imgW);
    initFilters(
        $('.popup .imap__filter'),
        $('.popup .imap__markers'),
        $('.popup .imap__intro'),
        $('.popup .imap__map')
    );
    scaleFilters($mapFilters);
    // pinch zoom
    hammerIt(document.querySelector('.popup .imap__map-outer'), 1, 2);
}
